import React from 'react';
import { motion } from 'framer-motion';

export const WaveGraphic = ({ className = "" }) => {
  return (
    <svg 
      className={`absolute w-full h-full pointer-events-none ${className}`} 
      viewBox="0 0 1440 400" 
      preserveAspectRatio="none"
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#7FE3C2" />
          <stop offset="100%" stopColor="#6BB8F0" />
        </linearGradient>
        <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="12" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>
      
      <motion.path
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{ duration: 2, ease: "easeInOut" }}
        d="M-100 250 C 300 350, 600 -50, 1540 150"
        stroke="url(#waveGradient)"
        strokeWidth="4"
        filter="url(#glow)"
        strokeLinecap="round"
      />
      
      {/* Subtle secondary wave */}
      <motion.path
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 0.3 }}
        transition={{ duration: 2.5, ease: "easeInOut", delay: 0.2 }}
        d="M-100 280 C 400 380, 800 -20, 1540 200"
        stroke="url(#waveGradient)"
        strokeWidth="2"
        filter="url(#glow)"
        strokeLinecap="round"
      />
    </svg>
  );
};